import { Clock } from "lucide-react";
import type { SwapStatusProduct } from "@/lib/api";

/**
 * Shown on a subscription while a product swap is PENDING support confirmation.
 * Surfaces the requested products (title + image, hydrated server-side) and
 * explains why cancel is unavailable until support confirms the swap.
 */
export function SwapPendingBanner({
  products,
}: {
  products: SwapStatusProduct[];
}) {
  return (
    <div className="tw:rounded-lg tw:border tw:border-dashed tw:border-amber-300 tw:bg-amber-50 tw:px-3 tw:py-2.5 tw:flex tw:flex-col tw:gap-2">
      <div className="tw:flex tw:items-center tw:gap-2 tw:text-[#523D33]">
        <Clock className="tw:w-4 tw:h-4 tw:shrink-0" />
        <span className="tw:text-sm tw:font-medium">
          Swap pending support confirmation
        </span>
      </div>
      <p className="tw:m-0 tw:text-xs tw:text-[#523D33]/70">
        Our team is setting up your product swap. You can't cancel this
        subscription until it's confirmed.
      </p>
      {products.length > 0 && (
        <div className="tw:flex tw:flex-wrap tw:gap-2 tw:pt-0.5">
          {products.map((p) => (
            <div
              key={p.id}
              className="tw:flex tw:items-center tw:gap-1.5 tw:rounded-md tw:border tw:border-amber-200 tw:bg-white tw:px-1.5 tw:py-1"
            >
              <div className="tw:size-8 tw:rounded tw:overflow-hidden tw:bg-gray-50 tw:flex tw:items-center tw:justify-center tw:shrink-0">
                {p.imageUrl ? (
                  <img
                    src={p.imageUrl}
                    alt={p.title}
                    className="tw:size-full tw:object-cover"
                  />
                ) : (
                  <span className="tw:text-[8px] tw:text-gray-400 tw:px-0.5 tw:text-center tw:leading-tight">
                    {p.title}
                  </span>
                )}
              </div>
              <span className="tw:text-[11px] tw:leading-tight tw:text-[#523D33] tw:max-w-28 tw:line-clamp-2">
                {p.title}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
